export const GOOGLE_MAPS_SERVICE_ID = 'google-maps-service';
export const GOOGLE_SDK_LINK = 'https://apis.google.com/js/api:client.js';
export const GOOGLE_SDK_SCRIPT_ID = 'google-sdk';
export const GTM_ID = 'GTM-KHH6J47';
export const GTM_EC_EVENT_FIELD = 'user_email';
export let GooglePlacesAutocompleteRequestType;

(function (GooglePlacesAutocompleteRequestType) {
  GooglePlacesAutocompleteRequestType["Geocode"] = "geocode";
  GooglePlacesAutocompleteRequestType["Address"] = "address";
  GooglePlacesAutocompleteRequestType["Establishment"] = "establishment";
})(GooglePlacesAutocompleteRequestType || (GooglePlacesAutocompleteRequestType = {}));

export let GoogleTagManagerEvent;

(function (GoogleTagManagerEvent) {
  GoogleTagManagerEvent["pageLoad"] = "page_load";
  GoogleTagManagerEvent["pageView"] = "pageView";
  GoogleTagManagerEvent["modalView"] = "modalView";
  GoogleTagManagerEvent["Login"] = "User_Login";
  GoogleTagManagerEvent["Register"] = "User_Register";
  GoogleTagManagerEvent["PhotoUpload"] = "Item_Photo_Upload";
  GoogleTagManagerEvent["ItemList"] = "Item_List";
  GoogleTagManagerEvent["ItemBuy"] = "Item_Buy";
  GoogleTagManagerEvent["ItemView"] = "Item_View_Details";
  GoogleTagManagerEvent["BuyStart"] = "Item_Buy_Start";
  GoogleTagManagerEvent["FirstList"] = "First_List";
  GoogleTagManagerEvent["FirstBuy"] = "First_Buy";
  GoogleTagManagerEvent["SecondDayList"] = "Second_Day_List";
})(GoogleTagManagerEvent || (GoogleTagManagerEvent = {}));

export let AddressComponentType;

(function (AddressComponentType) {
  AddressComponentType["Locality"] = "locality";
  AddressComponentType["Political"] = "political";
  AddressComponentType["Country"] = "country";
  AddressComponentType["PostalCode"] = "postal_code";
  AddressComponentType["StreetNumber"] = "street_number";
  AddressComponentType["Route"] = "route";
})(AddressComponentType || (AddressComponentType = {}));

export let PageType;

(function (PageType) {
  PageType["SearchResult"] = "Search Result Page";
  PageType["ProductDisplay"] = "Product Display Page";
  PageType["ProductListings"] = "Product Listings Page";
  PageType["Checkout"] = "Checkout Page";
  PageType["Favourites"] = "Favourites Page";
  PageType["Registration"] = "Register Page";
  PageType["Login"] = "Login Page";
  PageType["OrderComplete"] = "Order Complete Page";
  PageType["AddListing"] = "Add listing Page";
  PageType["Others"] = "Others";
})(PageType || (PageType = {}));

export let FormName;

(function (FormName) {
  FormName["Login"] = "Login";
  FormName["Register"] = "Register";
  FormName["AddListing"] = "Add listing";
  FormName["Checkout"] = "Checkout";
})(FormName || (FormName = {}));

export let LoginStatus;

(function (LoginStatus) {
  LoginStatus["Logged"] = "Logged In";
  LoginStatus["NotLogged"] = "Not Logged In";
})(LoginStatus || (LoginStatus = {}));